/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, BytesLike, BigNumberish } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { AmmFake } from "./AmmFake";

export class AmmFakeFactory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    _dcQuoteAssetReserve: BigNumberish,
    _dcBaseAssetReserve: BigNumberish,
    _dcTradeLimitRatio: BigNumberish,
    _fundingPeriod: BigNumberish,
    _priceFeed: string,
    _priceFeedKey: BytesLike,
    _quoteAsset: string,
    _fluctuation: BigNumberish,
    _tollRatio: BigNumberish,
    _spreadRatio: BigNumberish,
    overrides?: Overrides
  ): Promise<AmmFake> {
    return super.deploy(
      _dcQuoteAssetReserve,
      _dcBaseAssetReserve,
      _dcTradeLimitRatio,
      _fundingPeriod,
      _priceFeed,
      _priceFeedKey,
      _quoteAsset,
      _fluctuation,
      _tollRatio,
      _spreadRatio,
      overrides || {}
    ) as Promise<AmmFake>;
  }
  getDeployTransaction(
    _dcQuoteAssetReserve: BigNumberish,
    _dcBaseAssetReserve: BigNumberish,
    _dcTradeLimitRatio: BigNumberish,
    _fundingPeriod: BigNumberish,
    _priceFeed: string,
    _priceFeedKey: BytesLike,
    _quoteAsset: string,
    _fluctuation: BigNumberish,
    _tollRatio: BigNumberish,
    _spreadRatio: BigNumberish,
    overrides?: Overrides
  ): TransactionRequest {
    return super.getDeployTransaction(
      _dcQuoteAssetReserve,
      _dcBaseAssetReserve,
      _dcTradeLimitRatio,
      _fundingPeriod,
      _priceFeed,
      _priceFeedKey,
      _quoteAsset,
      _fluctuation,
      _tollRatio,
      _spreadRatio,
      overrides || {}
    );
  }
  attach(address: string): AmmFake {
    return super.attach(address) as AmmFake;
  }
  connect(signer: Signer): AmmFakeFactory {
    return super.connect(signer) as AmmFakeFactory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): AmmFake {
    return new Contract(address, _abi, signerOrProvider) as AmmFake;
  }
}

const _abi = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_dcQuoteAssetReserve",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_dcBaseAssetReserve",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_dcTradeLimitRatio",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_fundingPeriod",
        type: "uint256",
      },
      {
        internalType: "contract IPriceFeed",
        name: "_priceFeed",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "_priceFeedKey",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "_quoteAsset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_fluctuation",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_tollRatio",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_spreadRatio",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "maxHoldingBaseAsset",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "openInterestNotionalCap",
        type: "uint256",
      },
    ],
    name: "CapChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "int256",
        name: "rate",
        type: "int256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "underlyingPrice",
        type: "uint256",
      },
    ],
    name: "FundingRateUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "quoteReserve",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "baseReserve",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "int256",
        name: "cumulativeNotional",
        type: "int256",
      },
    ],
    name: "LiquidityChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "priceFeed",
        type: "address",
      },
    ],
    name: "PriceFeedUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "quoteAssetReserve",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "baseAssetReserve",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    name: "ReserveSnapshotted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "settlementPrice",
        type: "uint256",
      },
    ],
    name: "Shutdown",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "enum IAmm.Dir",
        name: "dir",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "quoteAssetAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "baseAssetAmount",
        type: "uint256",
      },
    ],
    name: "SwapInput",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "enum IAmm.Dir",
        name: "dir",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "quoteAssetAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "baseAssetAmount",
        type: "uint256",
      },
    ],
    name: "SwapOutput",
    type: "event",
  },
  {
    inputs: [],
    name: "baseAssetReserve",
    outputs: [
      {
        internalType: "uint256",
        name: "d",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "int256",
            name: "d",
            type: "int256",
          },
        ],
        internalType: "struct SignedDecimal.signedDecimal",
        name: "_baseAssetAmount",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "_fromQuoteReserve",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "_fromBaseReserve",
        type: "tuple",
      },
    ],
    name: "calcBaseAssetAfterLiquidityMigration",
    outputs: [
      {
        components: [
          {
            internalType: "int256",
            name: "d",
            type: "int256",
          },
        ],
        internalType: "struct SignedDecimal.signedDecimal",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "_quoteAssetAmount",
        type: "tuple",
      },
    ],
    name: "calcFee",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "candidate",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "fluctuationLimitRatio",
    outputs: [
      {
        internalType: "uint256",
        name: "d",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "fundingBufferPeriod",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "fundingPeriod",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "fundingRate",
    outputs: [
      {
        internalType: "int256",
        name: "d",
        type: "int256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getBaseAssetDelta",
    outputs: [
      {
        components: [
          {
            internalType: "int256",
            name: "d",
            type: "int256",
          },
        ],
        internalType: "struct SignedDecimal.signedDecimal",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getBaseAssetDeltaThisFundingPeriod",
    outputs: [
      {
        components: [
          {
            internalType: "int256",
            name: "d",
            type: "int256",
          },
        ],
        internalType: "struct SignedDecimal.signedDecimal",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getCumulativeNotional",
    outputs: [
      {
        components: [
          {
            internalType: "int256",
            name: "d",
            type: "int256",
          },
        ],
        internalType: "struct SignedDecimal.signedDecimal",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "enum IAmm.Dir",
        name: "_dir",
        type: "uint8",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "_quoteAssetAmount",
        type: "tuple",
      },
    ],
    name: "getInputPrice",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "enum IAmm.Dir",
        name: "_dir",
        type: "uint8",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "_quoteAssetAmount",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "_quoteAssetPoolAmount",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "_baseAssetPoolAmount",
        type: "tuple",
      },
    ],
    name: "getInputPriceWithReserves",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "enum IAmm.Dir",
        name: "_dir",
        type: "uint8",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "_quoteAssetAmount",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "_quoteAssetPoolAmount",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "_baseAssetPoolAmount",
        type: "tuple",
      },
    ],
    name: "getInputPriceWithReservesPublic",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "enum IAmm.Dir",
        name: "_dir",
        type: "uint8",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "_quoteAssetAmount",
        type: "tuple",
      },
    ],
    name: "getInputTwap",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getLatestLiquidityChangedSnapshots",
    outputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "int256",
                name: "d",
                type: "int256",
              },
            ],
            internalType: "struct SignedDecimal.signedDecimal",
            name: "cumulativeNotional",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "d",
                type: "uint256",
              },
            ],
            internalType: "struct Decimal.decimal",
            name: "quoteAssetReserve",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "d",
                type: "uint256",
              },
            ],
            internalType: "struct Decimal.decimal",
            name: "baseAssetReserve",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "int256",
                name: "d",
                type: "int256",
              },
            ],
            internalType: "struct SignedDecimal.signedDecimal",
            name: "totalPositionSize",
            type: "tuple",
          },
        ],
        internalType: "struct IAmm.LiquidityChangedSnapshot",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "i",
        type: "uint256",
      },
    ],
    name: "getLiquidityChangedSnapshots",
    outputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "int256",
                name: "d",
                type: "int256",
              },
            ],
            internalType: "struct SignedDecimal.signedDecimal",
            name: "cumulativeNotional",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "d",
                type: "uint256",
              },
            ],
            internalType: "struct Decimal.decimal",
            name: "quoteAssetReserve",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "d",
                type: "uint256",
              },
            ],
            internalType: "struct Decimal.decimal",
            name: "baseAssetReserve",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "int256",
                name: "d",
                type: "int256",
              },
            ],
            internalType: "struct SignedDecimal.signedDecimal",
            name: "totalPositionSize",
            type: "tuple",
          },
        ],
        internalType: "struct IAmm.LiquidityChangedSnapshot",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getLiquidityHistoryLength",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getMaxHoldingBaseAsset",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getOpenInterestNotionalCap",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "enum IAmm.Dir",
        name: "_dir",
        type: "uint8",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "_baseAssetAmount",
        type: "tuple",
      },
    ],
    name: "getOutputPrice",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "enum IAmm.Dir",
        name: "_dir",
        type: "uint8",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "_baseAssetAmount",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "_quoteAssetPoolAmount",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "_baseAssetPoolAmount",
        type: "tuple",
      },
    ],
    name: "getOutputPriceWithReserves",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "enum IAmm.Dir",
        name: "_dir",
        type: "uint8",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "_baseAssetAmount",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "_quoteAssetPoolAmount",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "_baseAssetPoolAmount",
        type: "tuple",
      },
    ],
    name: "getOutputPriceWithReservesPublic",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "enum IAmm.Dir",
        name: "_dir",
        type: "uint8",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "_baseAssetAmount",
        type: "tuple",
      },
    ],
    name: "getOutputTwap",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getReserve",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getSettlementPrice",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getSnapshotLen",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getSpotPrice",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_intervalInSeconds",
        type: "uint256",
      },
    ],
    name: "getTwapPrice",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getUnderlyingPrice",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_intervalInSeconds",
        type: "uint256",
      },
    ],
    name: "getUnderlyingTwapPrice",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "globalShutdown",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_quoteAssetReserve",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_baseAssetReserve",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_tradeLimitRatio",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_fundingPeriod",
        type: "uint256",
      },
      {
        internalType: "contract IPriceFeed",
        name: "_priceFeed",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "_priceFeedKey",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "_quoteAsset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_fluctuationLimitRatio",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_tollRatio",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_spreadRatio",
        type: "uint256",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "_quoteReserve",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "_baseReserve",
        type: "tuple",
      },
    ],
    name: "mockSetReserve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "mock_getCurrentBlockNumber",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "mock_getCurrentTimestamp",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_number",
        type: "uint256",
      },
    ],
    name: "mock_setBlockNumber",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_timestamp",
        type: "uint256",
      },
    ],
    name: "mock_setBlockTimestamp",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "nextFundingTime",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "open",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "priceFeed",
    outputs: [
      {
        internalType: "contract IPriceFeed",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "priceFeedKey",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "quoteAsset",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "quoteAssetReserve",
    outputs: [
      {
        internalType: "uint256",
        name: "d",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "reserveSnapshots",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "quoteAssetReserve",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "baseAssetReserve",
        type: "tuple",
      },
      {
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "blockNumber",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "_maxHoldingBaseAsset",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "_openInterestNotionalCap",
        type: "tuple",
      },
    ],
    name: "setCap",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_counterParty",
        type: "address",
      },
    ],
    name: "setCounterParty",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "_fluctuationLimitRatio",
        type: "tuple",
      },
    ],
    name: "setFluctuationLimitRatio",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_globalShutdown",
        type: "address",
      },
    ],
    name: "setGlobalShutdown",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "_open",
        type: "bool",
      },
    ],
    name: "setOpen",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "setOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IPriceFeed",
        name: "_priceFeed",
        type: "address",
      },
    ],
    name: "setPriceFeed",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_interval",
        type: "uint256",
      },
    ],
    name: "setSpotPriceTwapInterval",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "_spreadRatio",
        type: "tuple",
      },
    ],
    name: "setSpreadRatio",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "_tollRatio",
        type: "tuple",
      },
    ],
    name: "setTollRatio",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "settleFunding",
    outputs: [
      {
        components: [
          {
            internalType: "int256",
            name: "d",
            type: "int256",
          },
        ],
        internalType: "struct SignedDecimal.signedDecimal",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "shutdown",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "spotPriceTwapInterval",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "spreadRatio",
    outputs: [
      {
        internalType: "uint256",
        name: "d",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "enum IAmm.Dir",
        name: "_dir",
        type: "uint8",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "_quoteAssetAmount",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "_baseAssetAmountLimit",
        type: "tuple",
      },
    ],
    name: "swapInput",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "enum IAmm.Dir",
        name: "_dir",
        type: "uint8",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "_baseAssetAmount",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "_quoteAssetAmountLimit",
        type: "tuple",
      },
      {
        internalType: "bool",
        name: "_skipFluctuationCheck",
        type: "bool",
      },
    ],
    name: "swapOutput",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "tollAmount",
    outputs: [
      {
        internalType: "uint256",
        name: "d",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "tollRatio",
    outputs: [
      {
        internalType: "uint256",
        name: "d",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalPositionSize",
    outputs: [
      {
        internalType: "int256",
        name: "d",
        type: "int256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "tradeLimitRatio",
    outputs: [
      {
        internalType: "uint256",
        name: "d",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "updateOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";
